/**
 * Processing files of FGDB, Shapefile...
 */
import * as JSZip from 'jszip';
import { RE } from './FileReverseEng';
export var FP;
(function (FP) {
    var FileUtility = /** @class */ (function () {
        function FileUtility() {
        }
        // Get file name's extension, name without extentsion
        FileUtility.getFileNameParts = function (fName) {
            // File name without extension
            var nameNoExt = fName.slice(0, fName.lastIndexOf('.'));
            var nameSplits = fName.split('.');
            var extension = nameSplits[nameSplits.length - 1];
            extension = extension ? extension.toUpperCase() : '';
            return {
                ext: extension,
                nameNoExt: nameNoExt
            };
        };
        // This is for cases that may involve folders (not only files)
        FileUtility.getFilesFromDataTransferItems = function (items) {
            var entryPromises = [];
            var _loop_1 = function (i) {
                // If the item described by the DataTransferItem is a file, webkitGetAsEntry() returns a FileSystemFileEntry or FileSystemDirectoryEntry representing it.
                // If the item isn't a file, null is returned
                var entry = items[i].webkitGetAsEntry();
                if (entry) {
                    if (entry.isDirectory) {
                        var entryPromise = new Promise(function (resolveEntry, rejectEntry) {
                            var dirFiles = [];
                            var dirReader = entry.createReader();
                            // DO NOT use the method beblow due to Chrome issues. It will only read 100 entries in Chrome
                            // The problem with this is that readEntries is asynchronous, so I'm trying to call it while it's "busy" reading the first batch.
                            // dirReader.readEntries((entries) => {
                            // 	const entryFilePromises = [];
                            // 	entries.forEach((e) => {
                            // 		const entryFilePromise = new Promise((resolveFile, rejectFile) => {
                            // 			e.file((f) => {
                            // 				dirFiles.push(f);
                            // 				resolveFile();
                            // 			}, () => {
                            // 				rejectFile();
                            // 			});
                            // 		});
                            // 		entryFilePromises.push(entryFilePromise);
                            // 	});
                            // 	Promise.all(entryFilePromises).then(() => {
                            // 		resolveEntry({
                            // 			dirName: entry.name,
                            // 			files: dirFiles
                            // 		});
                            // 	})
                            // 	.catch(() => {
                            // 		rejectEntry();
                            // 	});
                            // });
                            // This method will solve the 100 entries limit issue in chrome
                            // Reference: https://stackoverflow.com/questions/51850469/file-and-directory-entries-api-broken-in-chrome
                            var entryFilePromises = [];
                            var read = function () {
                                dirReader.readEntries(function (entries) {
                                    if (entries.length > 0) {
                                        entries.forEach(function (e) {
                                            var entryFilePromise = new Promise(function (resolveFile, rejectFile) {
                                                e.file(function (f) {
                                                    dirFiles.push(f);
                                                    resolveFile();
                                                }, function () {
                                                    rejectFile();
                                                });
                                            });
                                            entryFilePromises.push(entryFilePromise);
                                        });
                                        read();
                                    }
                                    else {
                                        Promise.all(entryFilePromises).then(function () {
                                            resolveEntry({
                                                dirName: entry.name,
                                                files: dirFiles
                                            });
                                        })
                                            .catch(function () {
                                            rejectEntry();
                                        });
                                    }
                                });
                            };
                            read();
                        });
                        entryPromises.push(entryPromise);
                    }
                    else if (entry.isFile) {
                        var entryPromise = new Promise(function (resolveEntry, rejectEntry) {
                            entry.file(function (f) {
                                resolveEntry(f);
                            }, function () {
                                rejectEntry();
                            });
                        });
                        entryPromises.push(entryPromise);
                    }
                }
            };
            for (var i = 0; i < items.length; i++) {
                _loop_1(i);
            }
            return new Promise(function (resolve, reject) {
                Promise.all(entryPromises)
                    .catch(function (err) {
                    reject(err);
                })
                    .then(function (rsp) {
                    resolve(rsp);
                });
            });
        };
        // Group files by type and filter out whose type that can't be read
        // Param files: should be either directory files OR regular files. Can't be a mix of them.
        // Param FolderName: should be provided if files are from a folder
        FileUtility.groupFiles = function (files, folderName) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var filesByType = {
                    txt: {},
                    txtZip: {},
                    fgdb: {},
                    shp: {},
                    fgdbZip: {},
                    shpZip: {} // .zip
                };
                // Is fgdb folder (not including zip)
                var isFgdb;
                var shpExtensions = ['SHP', 'PRJ', 'DBF', 'SHX'];
                var fgdbExtensions = ['GDBTABLE', 'GDBTABLX'];
                var txtExtensions = ['CSV', 'TXT'];
                var fgdbExcludedFiles = ['a00000001', 'a00000002', 'a00000003', 'a00000005', 'a00000006', 'a00000007', 'a00000008'];
                var promises = [];
                var _loop_2 = function (i) {
                    var file = files[i];
                    var nameParts = _this.getFileNameParts(file.name);
                    var nameNoExt = nameParts.nameNoExt;
                    var extension = nameParts.ext;
                    switch (extension) {
                        case 'TXT':
                        case 'CSV':
                            // // Use name instead of nameNoExt
                            // filesByType.txt[file.name] = {
                            // 	file: file
                            // };
                            filesByType.txt[file.name] = {
                                file: file
                            };
                            break;
                        case 'DBF':
                        case 'SHP':
                        case 'PRJ':
                        case 'SHX':
                            if (!filesByType.shp[nameNoExt]) {
                                filesByType.shp[nameNoExt] = {
                                    files: {
                                        SHP: null,
                                        SHX: null,
                                        DBF: null,
                                        PRJ: null
                                    },
                                    info: null,
                                    zip: null
                                };
                            }
                            filesByType.shp[nameNoExt].files[extension] = file;
                            break;
                        case 'ZIP':
                            var promise = new Promise(function (resolveZ, rejectZ) {
                                _this.readZip(file).then(function (rsp) {
                                    // Check zip is shp or fgdb or txt
                                    // const fgdbNames = ['a00000004.gdbtable', 'a00000004.gdbtablx'];
                                    var zipType;
                                    var _loop_4 = function (f) {
                                        // Make sure f is not a directory
                                        if (rsp.files[f].dir) {
                                            return "continue";
                                        }
                                        // Make sure f has name
                                        var splits = f.split('/');
                                        var fName = splits[splits.length - 1];
                                        if (!fName) {
                                            return "continue";
                                        }
                                        var fNameParts = _this.getFileNameParts(fName);
                                        var fExt = fNameParts.ext;
                                        var fNameNoExt = fNameParts.nameNoExt;
                                        var checkFunc = function (type) {
                                            switch (type) {
                                                case 'shp':
                                                    // Check shp extensions
                                                    var extIndexS = shpExtensions.indexOf(fExt);
                                                    if (extIndexS !== -1) {
                                                        // Add File to filesByType
                                                        if (!filesByType.shpZip[nameNoExt]) {
                                                            filesByType.shpZip[nameNoExt] = {
                                                                zip: file,
                                                                layers: {}
                                                            };
                                                        }
                                                        if (!filesByType.shpZip[nameNoExt].layers[fNameNoExt]) {
                                                            filesByType.shpZip[nameNoExt].layers[fNameNoExt] = {
                                                                unzips: {},
                                                                info: null
                                                            };
                                                        }
                                                        filesByType.shpZip[nameNoExt].layers[fNameNoExt].unzips[fExt] = rsp.files[f];
                                                    }
                                                    break;
                                                case 'fgdb':
                                                    // File extension need to be in fgdbExtensions
                                                    var extIndexF = fgdbExtensions.indexOf(fExt);
                                                    if (extIndexF === -1) {
                                                        break;
                                                    }
                                                    // File name can not be in fgdbExcludedFiles
                                                    var excludeIndexF_1 = fgdbExcludedFiles.indexOf(fNameNoExt);
                                                    if (excludeIndexF_1 !== -1) {
                                                        break;
                                                    }
                                                    // Add File to filesByType
                                                    if (!filesByType.fgdbZip[nameNoExt]) {
                                                        filesByType.fgdbZip[nameNoExt] = {
                                                            zip: file,
                                                            unzips: {}
                                                        };
                                                    }
                                                    if (!filesByType.fgdbZip[nameNoExt].unzips[fNameNoExt]) {
                                                        filesByType.fgdbZip[nameNoExt].unzips[fNameNoExt] = {};
                                                    }
                                                    filesByType.fgdbZip[nameNoExt].unzips[fNameNoExt][fExt] = rsp.files[f];
                                                    break;
                                                case 'txt':
                                                    // File extension need to be in txtExtensions
                                                    var extIndexTxt = txtExtensions.indexOf(fExt);
                                                    if (extIndexTxt === -1) {
                                                        break;
                                                    }
                                                    // Add File to filesByType
                                                    if (!filesByType.txtZip[nameNoExt]) {
                                                        filesByType.txtZip[nameNoExt] = {
                                                            zip: file,
                                                            layers: {}
                                                        };
                                                    }
                                                    // Use fName instead of nameNoExt here. Since XXX.txt and XXX.csv could be two different layers
                                                    filesByType.txtZip[nameNoExt].layers[fName] = {
                                                        unzip: rsp.files[f]
                                                    };
                                                    break;
                                                default:
                                                    var extIndexShp = shpExtensions.indexOf(fExt);
                                                    if (extIndexShp !== -1) {
                                                        zipType = 'shp';
                                                        checkFunc(zipType);
                                                    }
                                                    else if (fgdbExtensions.indexOf(fExt) !== -1) {
                                                        // File extension need to be in fgdbExtensions
                                                        zipType = 'fgdb';
                                                        checkFunc(zipType);
                                                        // // File extension need to be in fgdbExtensions
                                                        // const extIndexFgdb = fgdbExtensions.indexOf(fExt);
                                                        // if (extIndexFgdb === -1) { break; }
                                                        // zipType = 'fgdb';
                                                        // checkFunc(zipType);
                                                    }
                                                    else if (txtExtensions.indexOf(fExt) !== -1) {
                                                        zipType = 'txt';
                                                        checkFunc(zipType);
                                                    }
                                            }
                                        };
                                        checkFunc(zipType);
                                    };
                                    for (var _i = 0, _a = Object.keys(rsp.files); _i < _a.length; _i++) {
                                        var f = _a[_i];
                                        _loop_4(f);
                                    }
                                    resolveZ();
                                }).catch(function (err) {
                                    resolveZ();
                                });
                            });
                            promises.push(promise);
                            break;
                        case 'GDBTABLE':
                        case 'GDBTABLX':
                            // If it's unzipped FGDB, the files has to be uploaded from a folder (instead of selecting raw fgdb files directly)
                            if (!folderName) {
                                break;
                            }
                            // File name can not be in fgdbExcludedFiles
                            var excludeIndexF = fgdbExcludedFiles.indexOf(nameNoExt);
                            if (excludeIndexF !== -1) {
                                break;
                            }
                            isFgdb = true;
                            // Add File to filesByType
                            if (!filesByType.fgdb[folderName]) {
                                filesByType.fgdb[folderName] = {
                                    zip: null,
                                    files: {},
                                    rawFiles: null
                                };
                            }
                            if (!filesByType.fgdb[folderName].files[nameNoExt]) {
                                filesByType.fgdb[folderName].files[nameNoExt] = {};
                            }
                            filesByType.fgdb[folderName].files[nameNoExt][extension] = file;
                        // TODO !!!!!!!!!!!!!!!!!
                        // // Remove .gdb from name according to Jinzhou
                        // const gdbExt = nameSplits[nameSplits.length - 2];
                        // if (gdbExt && gdbExt.toUpperCase() === 'GDB') {
                        // 	const name = nameNoExt.slice(0, nameNoExt.lastIndexOf('.'));
                        // 	filesByType.fgdb[name] = file;
                        // }
                    }
                    if (isFgdb) {
                        filesByType.fgdb[folderName].rawFiles = files;
                    }
                };
                for (var i = 0; i < files.length; i++) {
                    _loop_2(i);
                }
                var _loop_3 = function (name_1) {
                    if (!_this.checkFgdbComplete(filesByType.fgdb[name_1].files)) {
                        delete filesByType.fgdb[name_1];
                        return "continue";
                    }
                    // Generate zip file
                    var zipPromise = new Promise(function (resolveZip, rejectZip) {
                        _this.generateZip(filesByType.fgdb[name_1].rawFiles).then(function (rsp) {
                            filesByType.fgdb[name_1].zip = rsp;
                            resolveZip();
                        }).catch(function () {
                            rejectZip();
                        });
                    });
                    promises.push(zipPromise);
                };
                for (var _i = 0, _a = Object.keys(filesByType.fgdb); _i < _a.length; _i++) {
                    var name_1 = _a[_i];
                    _loop_3(name_1);
                }
                Promise.all(promises).then(function (rsp) {
                    resolve(filesByType);
                })
                    .catch(function (err) {
                    reject(err);
                });
            });
        };
        // Group files which include regular ones and those uploaded from directories
        FileUtility.groupFilesMix = function (files) {
            return new Promise(function (resolve, reject) {
                var promisesGroupedFiles = [];
                var filesNotDir = [];
                files.forEach(function (data) {
                    // Direcotry files
                    if (data.hasOwnProperty('dirName')) {
                        //
                        var promiseDir = FP.FileUtility.groupFiles(data.files, data.dirName);
                        promisesGroupedFiles.push(promiseDir);
                    }
                    else { // Regular files
                        filesNotDir.push(data);
                    }
                });
                var promiseRegular = FP.FileUtility.groupFiles(filesNotDir);
                promisesGroupedFiles.push(promiseRegular);
                Promise.all(promisesGroupedFiles)
                    .catch(function (err) {
                    reject(err);
                })
                    .then(function (rspGroupedFiles) {
                    var groupedFiles = FP.GeneralUtility.mergeObjectsLevel1(rspGroupedFiles);
                    // rspGroupedFiles.reduce((acc, g) => {
                    // 	if (g) {
                    // 		for (const key of Object.keys(g)) {
                    // 			if (!acc[key]) {
                    // 				acc[key] = g[key];
                    // 			} else {
                    // 				for (const subKey of Object.keys(g[key])) {
                    // 					acc[key][subKey] = g[key][subKey];
                    // 				}
                    // 			}
                    // 		}
                    // 	}
                    // 	return acc;
                    // });
                    resolve(groupedFiles);
                });
            });
        };
        // Process grouped files.
        // Including reading shp / fgdb...
        FileUtility.processFilesByType = function (filesByType, options) {
            var _this = this;
            var promises = [];
            if (filesByType.fgdbZip) {
                var _loop_5 = function (name_2) {
                    var promise = new Promise(function (resolveFgdb, rejectFgdb) {
                        if (!_this.checkFgdbComplete(filesByType.fgdbZip[name_2].unzips)) {
                            resolveFgdb();
                        }
                        else {
                            _this.readFgdbFiles(filesByType.fgdbZip[name_2].unzips, true).then(function (rspFgdb) {
                                filesByType.fgdbZip[name_2].layers = rspFgdb;
                                resolveFgdb();
                            }).catch(function (err) {
                                rejectFgdb(err);
                            });
                        }
                    });
                    promises.push(promise);
                };
                for (var _i = 0, _a = Object.keys(filesByType.fgdbZip); _i < _a.length; _i++) {
                    var name_2 = _a[_i];
                    _loop_5(name_2);
                }
            }
            if (filesByType.shpZip) {
                var _loop_6 = function (name_3) {
                    var _loop_11 = function (layerName) {
                        var promise = new Promise(function (resolveShpZip, rejectShpZip) {
                            _this.readShapefiles_Z(filesByType.shpZip[name_3].layers[layerName], options).then(function (rspShpZip) {
                                filesByType.shpZip[name_3].layers[layerName].info = rspShpZip;
                                resolveShpZip();
                            }).catch(function (err) {
                                rejectShpZip();
                            });
                        });
                        promises.push(promise);
                    };
                    for (var _i = 0, _a = Object.keys(filesByType.shpZip[name_3].layers); _i < _a.length; _i++) {
                        var layerName = _a[_i];
                        _loop_11(layerName);
                    }
                };
                for (var _b = 0, _c = Object.keys(filesByType.shpZip); _b < _c.length; _b++) {
                    var name_3 = _c[_b];
                    _loop_6(name_3);
                }
            }
            if (filesByType.shp) {
                var _loop_7 = function (name_4) {
                    // Create a zip file
                    var files = [];
                    for (var _i = 0, _a = Object.keys(filesByType.shp[name_4].files); _i < _a.length; _i++) {
                        var f = _a[_i];
                        files.push(filesByType.shp[name_4].files[f]);
                    }
                    var zipPromise = new Promise(function (resolveZip, rejectZip) {
                        _this.generateZip(files).then(function (rsp) {
                            filesByType.shp[name_4].zip = rsp;
                            resolveZip();
                        }).catch(function () {
                            rejectZip();
                        });
                    });
                    promises.push(zipPromise);
                    // filesByType.shp[name].zip = this.generateZip(files);
                    // Read
                    var promise = new Promise(function (resolveShp, rejectShp) {
                        _this.readShapefiles_F(filesByType.shp[name_4].files, name_4, options).then(function (rspShp) {
                            filesByType.shp[name_4].info = rspShp;
                            resolveShp();
                        }).catch(function () {
                            delete filesByType.shp[name_4];
                            resolveShp();
                        });
                    });
                    promises.push(promise);
                };
                for (var _d = 0, _e = Object.keys(filesByType.shp); _d < _e.length; _d++) {
                    var name_4 = _e[_d];
                    _loop_7(name_4);
                }
            }
            if (filesByType.fgdb) {
                var _loop_8 = function (name_5) {
                    var promise = new Promise(function (resolveFgdb, rejectFgdb) {
                        _this.readFgdbFiles(filesByType.fgdb[name_5].files)
                            .catch(function () { rejectFgdb(); })
                            .then(function (rspFgdb) {
                            filesByType.fgdb[name_5].layers = rspFgdb;
                            resolveFgdb();
                        });
                    });
                    promises.push(promise);
                };
                for (var _f = 0, _g = Object.keys(filesByType.fgdb); _f < _g.length; _f++) {
                    var name_5 = _g[_f];
                    _loop_8(name_5);
                }
            }
            if (filesByType.txtZip) {
                var _loop_9 = function (name_6) {
                    var _loop_12 = function (layerName) {
                        var promise = new Promise(function (resolveTxtZip, rejectTxtZip) {
                            _this.readTxt_z(filesByType.txtZip[name_6].layers[layerName].unzip).then(function (rsp) {
                                filesByType.txtZip[name_6].layers[layerName].binaryString = rsp.binaryString;
                                resolveTxtZip();
                            }).catch(function () {
                                rejectTxtZip(); // TODO
                            });
                        });
                        promises.push(promise);
                    };
                    for (var _i = 0, _a = Object.keys(filesByType.txtZip[name_6].layers); _i < _a.length; _i++) {
                        var layerName = _a[_i];
                        _loop_12(layerName);
                    }
                };
                for (var _h = 0, _j = Object.keys(filesByType.txtZip); _h < _j.length; _h++) {
                    var name_6 = _j[_h];
                    _loop_9(name_6);
                }
            }
            if (filesByType.txt) {
                var _loop_10 = function (name_7) {
                    var zipPromise = new Promise(function (resolveZip, rejectZip) {
                        _this.generateZip([filesByType.txt[name_7].file]).then(function (rsp) {
                            filesByType.txt[name_7].zip = rsp;
                            resolveZip();
                        }).catch(function () {
                            rejectZip();
                        });
                    });
                    promises.push(zipPromise);
                    var promise = new Promise(function (resolveTxt, rejectTxt) {
                        var reader = new FileReader();
                        reader.onload = function () {
                            filesByType.txt[name_7].binaryString = reader.result;
                            resolveTxt();
                        };
                        reader.readAsBinaryString(filesByType.txt[name_7].file);
                    });
                    promises.push(promise);
                };
                for (var _k = 0, _l = Object.keys(filesByType.txt); _k < _l.length; _k++) {
                    var name_7 = _l[_k];
                    _loop_10(name_7);
                }
            }
            return new Promise(function (resolve, reject) {
                Promise.all(promises)
                    .catch(function (err) {
                    reject(err);
                }).then(function () {
                    resolve(filesByType);
                });
            });
        };
        // Read zip files
        FileUtility.readZip = function (file, successCallback, errorCallback, options) {
            return new Promise(function (resolve, reject) {
                var zip = new JSZip();
                zip.loadAsync(file, options)
                    .then(function (rsp) {
                    resolve(rsp);
                    if (successCallback) {
                        successCallback(rsp);
                    }
                }).catch(function (err) {
                    reject(err);
                    if (errorCallback) {
                        errorCallback(err);
                    }
                });
            });
        };
        // Read fgdb files
        // isJSZip: is files to read unziped from a .zip or regular files
        FileUtility.readFgdbFiles = function (files, isJSZip, successCallback, errorCallback) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var fgdb = files;
                var getPromise = function (fileToRead) {
                    var promiseFileToRead;
                    if (isJSZip) {
                        promiseFileToRead = fileToRead.async('arraybuffer');
                    }
                    else {
                        promiseFileToRead = new Promise(function (resolveFileToRead, rejectFileToRead) {
                            var reader = new FileReader();
                            reader.onload = function () {
                                resolveFileToRead(reader.result);
                            };
                            reader.readAsArrayBuffer(fileToRead);
                        });
                    }
                    return promiseFileToRead;
                };
                // Read a00000004 file before reading other files
                getPromise(fgdb['a00000004'].GDBTABLX).then(function (rsp04Tablx) {
                    var results = RE.Fgdb.interpretGdbTablx(rsp04Tablx);
                    // Read layers info
                    // fgdb['a00000004'].GDBTABLE.async('arraybuffer').then((rsp04Table) => {
                    getPromise(fgdb['a00000004'].GDBTABLE).then(function (rsp04Table) {
                        var results04Table = RE.Fgdb.interpretGdbTable(rsp04Table, results.rowStartPos, true);
                        // Start reading other files
                        var promisesLayers = [];
                        var _loop_13 = function (name_8) {
                            if (name_8 === 'a00000004') {
                                return "continue";
                            }
                            var file = fgdb[name_8];
                            if (!file.GDBTABLE || !file.GDBTABLX) {
                                return "continue";
                            }
                            var layerPromise = new Promise(function (resolveL, rejectL) {
                                getPromise(file.GDBTABLX).then(function (rspLayerTablx) {
                                    var resultLayerTablx = RE.Fgdb.interpretGdbTablx(rspLayerTablx);
                                    getPromise(file.GDBTABLE).then(function (rspLayerTable) {
                                        var resultLayerTable = RE.Fgdb.interpretGdbTable(rspLayerTable, resultLayerTablx.rowStartPos, 20);
                                        resultLayerTable.fileName = name_8;
                                        resultLayerTable.fields.forEach(function (field) {
                                            var convertedType = FP.FileSpec.convertFieldTypeFgdb(field.type);
                                            Object.assign(field, convertedType);
                                        });
                                        resultLayerTable.fields.sort(FP.GeneralUtility.sortFieldByName);
                                        resolveL(resultLayerTable);
                                    }).catch(function (err) { return rejectL(err); });
                                }).catch(function (err) { return rejectL(err); });
                            });
                            promisesLayers.push(layerPromise);
                        };
                        for (var _i = 0, _a = Object.keys(fgdb); _i < _a.length; _i++) {
                            var name_8 = _a[_i];
                            _loop_13(name_8);
                        }
                        Promise.all(promisesLayers).then(function (rspLayerContents) {
                            var layers = _this.fgdbMatchLayerAndCols(results04Table.rows, rspLayerContents);
                            if (successCallback) {
                                successCallback(layers);
                            }
                            resolve(layers);
                        }).catch(function (err) {
                            reject(err);
                        });
                    }).catch(function (err) { return reject(); });
                }).catch(function (err) { return reject(); });
            });
        };
        // Match layers (read from a00000004) with columns (read from a00000009/a/b..) in a FGDB
        FileUtility.fgdbMatchLayerAndCols = function (layers, contents) {
            // Filter layers
            layers = layers.slice(2, layers.length); // The first record is reserved for a kind of root item ( Name = "", Path = "" ). The second record is reserved for a Name = "Workspace" item, Path = ""
            layers = layers.filter(function (l) {
                return !!l.Path; // && l.DatasetInfo1;
            });
            // // Filter contents
            // contents = contents.filter((c) => {
            // 	return !!c.geomType;
            // });
            var layersByName = {};
            for (var _i = 0, contents_1 = contents; _i < contents_1.length; _i++) {
                var c = contents_1[_i];
                var orderStr = c.fileName.split('.')[0];
                if (orderStr) {
                    orderStr = orderStr.substr(orderStr.length - 3);
                    c.order = parseInt(orderStr, 16);
                }
            }
            // Sort contents by name
            contents.sort(function (a, b) {
                return a.order - b.order;
            });
            for (var i = 0, j = 0; i < layers.length; i++) {
                // if (!layers[i].Path) {
                // 	continue;
                // }
                contents[j].layerName = layers[i].Name;
                contents[j].type = contents[j].geomType;
                delete contents[j].geomType; // TODO
                layersByName[layers[i].Name] = contents[j];
                // Get projection from layer definition xml
                var epsgNum = void 0;
                var reg = /(epsg)(\D*)(\d+)/i;
                var match = layers[i].Definition.match(reg);
                epsgNum = match ? match[3] : null;
                if (epsgNum) {
                    layersByName[layers[i].Name].epsg = epsgNum;
                }
                j++;
            }
            return layersByName;
        };
        // Read Shapefiles unziped from a .zip
        FileUtility.readShapefiles_Z = function (files, successCallback, errorCallback, options) {
            return new Promise(function (resolve, reject) {
                var shapefile = files;
                // Read DBF
                shapefile.unzips.DBF.async('arraybuffer').then(function (rspDbf) {
                    var shpOptions;
                    if (options) {
                        shpOptions = {};
                        shpOptions.previewNum = options.previewNumShp;
                    }
                    var resultsDbf = RE.Shapefile.interpretDbf(rspDbf, shpOptions);
                    var partsPromises = [];
                    // Read PRJ
                    var promisePrj = new Promise(function (resolvePrj, rejectPrj) {
                        // file.epsgOrigin = this.getEpsgFromWktPrj(reader.result);
                        shapefile.unzips.PRJ.async('text').then(function (rspPrj) {
                            var resultPrj = RE.Shapefile.interpretPrj(rspPrj);
                            resolvePrj(resultPrj);
                        });
                    });
                    partsPromises.push(promisePrj);
                    // Read Shp
                    var promiseShp = new Promise(function (resolveShp, rejectShp) {
                        shapefile.unzips.SHP.async('arraybuffer').then(function (rspShp) {
                            var resultShp = RE.Shapefile.interpretShp(rspShp);
                            resolveShp(resultShp);
                        });
                    });
                    partsPromises.push(promiseShp);
                    Promise.all(partsPromises)
                        .then(function (rsp) {
                        resolve({
                            fields: resultsDbf.headers.map(function (h) {
                                var convertedType = FP.FileSpec.convertFieldTypeDbf(h.type);
                                var field = {
                                    name: h.name,
                                    type: h.type,
                                    length: h.length
                                };
                                return Object.assign(field, convertedType);
                            }).sort(FP.GeneralUtility.sortFieldByName),
                            epsg: rsp[0] ? rsp[0].epsg : null,
                            type: rsp[1] ? rsp[1].type : null,
                            rows: resultsDbf.rows,
                            numOfRecords: resultsDbf.numOfRecords
                        });
                    })
                        .catch(function (e) {
                        reject();
                    });
                });
            });
        };
        // Read shapefiles from folder
        FileUtility.readShapefiles_F = function (files, name, options) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var shapefilesByName = files;
                // Check missing files
                if (!_this.checkShpComplete(files, name)) {
                    reject();
                    return;
                }
                // Read DBF
                var shpOptions;
                if (options) {
                    shpOptions = {};
                    shpOptions.previewNum = options.previewNumShp;
                }
                RE.Shapefile.readDbf(shapefilesByName.DBF, shpOptions)
                    .then(function (resultsDbf) {
                    var partsPromises = [];
                    // Read PRJ
                    var promisePrj = new Promise(function (resolvePrj, rejectPrj) {
                        RE.Shapefile.readPrj(shapefilesByName.PRJ).then(function (resultsPrj) {
                            resolvePrj(resultsPrj);
                        });
                    });
                    partsPromises.push(promisePrj);
                    // Read Shp
                    var promiseShp = new Promise(function (resolveShp, rejectShp) {
                        RE.Shapefile.readShp(shapefilesByName.SHP).then(function (resultsShp) {
                            resolveShp(resultsShp);
                        });
                    });
                    partsPromises.push(promiseShp);
                    Promise.all(partsPromises)
                        .then(function (rsp) {
                        resolve({
                            fields: resultsDbf.headers.map(function (h) {
                                var convertedType = FP.FileSpec.convertFieldTypeDbf(h.type);
                                var field = {
                                    name: h.name,
                                    type: h.type,
                                    length: h.length
                                };
                                return Object.assign(field, convertedType);
                            }).sort(FP.GeneralUtility.sortFieldByName),
                            epsg: rsp[0] ? rsp[0].epsg : null,
                            type: rsp[1] ? rsp[1].type : null,
                            rows: resultsDbf.rows,
                            numOfRecords: resultsDbf.numOfRecords
                        });
                    })
                        .catch();
                });
            });
        };
        // Read txt file unziped from a .zip
        FileUtility.readTxt_z = function (file, eventColumnSeparator, previewRowNum) {
            return new Promise(function (resolve, reject) {
                if (!previewRowNum && previewRowNum !== 0) {
                    previewRowNum = 10;
                }
                file.async('binarystring').then(function (rsp) {
                    resolve({
                        binaryString: rsp
                    });
                }).catch(function () {
                    resolve({ binaryString: '' });
                });
            });
        };
        // Check if shapefile contains all the required files
        FileUtility.checkShpComplete = function (shapefile, name) {
            if (!shapefile.DBF) {
                alert('Missing dbf file of ' + name);
                return false;
            }
            else if (!shapefile.SHP) {
                alert('Missing shp file of ' + name);
                return false;
            }
            else if (!shapefile.PRJ) {
                alert('Missing prj file of ' + name);
                return false;
            }
            else if (!shapefile.SHX) {
                alert('Missing shx file of ' + name);
                return false;
            }
            return true;
        };
        // Check if fgdb contains all the required files
        FileUtility.checkFgdbComplete = function (fgdb) {
            if (!fgdb['a00000004']) {
                alert('Missing a00000004 file!');
                return false;
            }
            if (!fgdb['a00000004'].GDBTABLX) {
                alert('Missing a00000004.gdbtablx file!');
                return false;
            }
            if (!fgdb['a00000004'].GDBTABLE) {
                alert('Missing a00000004.gdbtable file!');
                return false;
            }
            return true;
        };
        // Create a zip file
        FileUtility.generateZip = function (files) {
            return new Promise(function (resolve, reject) {
                var zip = new JSZip();
                for (var i = 0; i < files.length; i++) {
                    zip.file(files[i].name, files[i]);
                }
                zip.generateAsync({ type: 'blob' }).then(function (content) {
                    resolve(content);
                }).catch(function (err) {
                    reject();
                });
            });
        };
        return FileUtility;
    }());
    FP.FileUtility = FileUtility;
    var GeneralUtility = /** @class */ (function () {
        function GeneralUtility() {
        }
        // Merge two objects by first level of properties
        // E.g. objA = {A: {AA: 1}, B: {AB: 1}}  objB = {A: {BB: 1}, B: {BB: 2}}
        // Result would be {A: {AA: 1, BB: 1}, B: {AB: 1, BB: 2}}
        GeneralUtility.mergeObjectsLevel1 = function (objectsArray) {
            var mergedObj = objectsArray.reduce(function (acc, obj) {
                if (obj) {
                    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (!acc[key]) {
                            acc[key] = obj[key];
                        }
                        else {
                            for (var _b = 0, _c = Object.keys(obj[key]); _b < _c.length; _b++) {
                                var subKey = _c[_b];
                                acc[key][subKey] = obj[key][subKey];
                            }
                        }
                    }
                }
                return acc;
            });
            return mergedObj;
        };
        GeneralUtility.sortFieldByName = function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            else if (a.name < b.name) {
                return -1;
            }
            else {
                return 0;
            }
        };
        return GeneralUtility;
    }());
    FP.GeneralUtility = GeneralUtility;
    var FileSpec = /** @class */ (function () {
        function FileSpec() {
        }
        // lrsCols, attrCols: Default true
        FileSpec.initLayerJson = function (lrsCols, attrCols) {
            var fileJson = {
                name: '',
                type: '',
                sequence: null,
                layer_spec: null,
                maint_type: null
            };
            // Default: have lrsCols and attrCols
            if (lrsCols || lrsCols === undefined) {
                fileJson.lrs_cols = [];
            }
            if (attrCols || attrCols === undefined) {
                fileJson.attr_cols = [];
            }
            return fileJson;
        };
        FileSpec.initLayerJsonCsv = function (name, type, maintainType, delimiter, lrsCols, attrCols) {
            return {
                name: name,
                type: type,
                sequence: null,
                maint_type: maintainType,
                layer_spec: {
                    delimiter: delimiter
                },
                lrs_cols: lrsCols || null,
                attr_cols: attrCols || null
            };
        };
        FileSpec.initFilesJsonSpatial = function () {
            return {
                uniqueName: '',
                name: '',
                type: null,
                layers: []
            };
        };
        FileSpec.initFilesJsonCsv = function (name, layers) {
            return {
                name: name,
                type: 'csv',
                layers: layers || []
            };
        };
        FileSpec.convertFeatureType = function (featureType) {
            switch (featureType) {
                case 'Point':
                case 'MultiPoint':
                case 'PointZ':
                case 'MultiPointZ':
                    return 'GP';
                case 'PointM':
                case 'MultiPointM':
                    return 'GPM';
                case 'PolyLine':
                    return 'GL';
                case 'PolyLineM':
                    return 'GLM';
                case 'PolyLineZ':
                // TODO!!!!!!!!!
                case 'Polygon':
                    return 'GA';
            }
        };
        FileSpec.getFeatureFileJsonFgdb = function (fgdb, name) {
            var filesJson = {
                name: name,
                layers: []
            };
            // fgdb.forEach((l) => {
            // 	const layerJson: any = {};
            // 	layerJson.source = l.name;
            // 	layerJson.name = l.name;
            // 	layerJson.type = l.featureTypeShp;
            // 	layerJson.file_spec = {
            // 		type: 'fgdb',
            // 		srid: l.epsgOrigin || l.epsgInput,
            // 		proj4: null,
            // 		geom_col: 'geom'
            // 	};
            // 	layerJson.arnold = l.featureType === 'arnold' ? 1 : 0;
            // 	const columnsInfo = this.getFeatureColumnsInfo(l.matchingColumns);
            // 	const cols = this.setFeatureFileLrsAttrCols(columnsInfo, l.headers);
            // 	layerJson.lrs_cols = cols.lrs;
            // 	layerJson.attr_cols = cols.attr;
            // 	filesJson.layers.push(layerJson);
            // });
            return filesJson;
        };
        // Convert the field type read from dbf to LB Type and NENA Type
        FileSpec.convertFieldTypeDbf = function (fieldType) {
            switch (fieldType) {
                case 'Y':
                case 'N':
                case 'F':
                case 'B':
                case 'I':
                    return {
                        LBType: 'number',
                    };
                case 'C':
                case 'M':
                    return {
                        LBType: 'text',
                    };
                case 'D':
                    return {
                        LBType: 'date',
                    };
                case 'L':
                    return {
                        LBType: 'bool',
                    };
                default:
                    return {
                        LBType: '',
                    };
            }
        };
        // Convert the field type read from fgdb to LB Type and NENA Type
        FileSpec.convertFieldTypeFgdb = function (fieldType) {
            switch (fieldType) {
                case 0:
                case 1:
                case 6:
                    return {
                        LBType: 'number',
                    };
                case 4:
                case 12:
                    return {
                        LBType: 'text',
                    };
                case 10:
                case 11:
                    return {
                        LBType: 'uuid'
                    };
                case 5:
                    return {
                        LBType: 'date',
                    };
                case 7:
                    return {
                        LBType: 'geom',
                    };
                case 8:
                    return {
                        LBType: 'bool',
                    };
                case 2:
                case 3:
                    return {
                        LBType: 'number',
                    };
                default:
                    return {
                        LBType: '',
                    };
            }
        };
        // TXT: get layers by a column value
        FileSpec.getTxtLayersByColumn = function (fileData, delimiter, col) {
            var layersByName = {};
            if (!fileData || !fileData[0]) {
                return;
            }
            // Default column: 'Data_Item'
            col = col || 'Data_Item';
            // Get headers from first line
            var headers = fileData[0].split(delimiter);
            // Layer name column index in headers
            var colIdx = headers.indexOf(col);
            if (colIdx !== -1) {
                // Loop fileData from second line
                for (var i = 1; i < fileData.length; i++) {
                    if (!fileData[i]) {
                        continue;
                    }
                    // Layer name
                    var name_9 = fileData[i].split(delimiter)[colIdx];
                    // Create layer if not existing
                    if (!layersByName[name_9]) {
                        layersByName[name_9] = {
                            fileData: [fileData[0]],
                            name: name_9
                        };
                    }
                    // Push to fileData
                    layersByName[name_9].fileData.push(fileData[i]);
                }
            }
            return layersByName;
        };
        return FileSpec;
    }());
    FP.FileSpec = FileSpec;
})(FP || (FP = {}));
